import React, { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { InputAdornment, TextField } from '@material-ui/core';

import CorrectIcon from 'assets/img/correct.png';
import WrongIcon from 'assets/img/wrong.png';

import styles from './ReferenceField.module.scss';

function ReferenceField({
  errorMsg,
  hasStock,
  isValidReference,
  mediaMobile = false,
  reference,
  setReference,
}: {
  errorMsg: string;
  hasStock: boolean;
  isValidReference: boolean;
  mediaMobile?: boolean;
  reference?: string;
  setReference: (ref: string) => void;
}): JSX.Element {
  const { t } = useTranslation();
  const [referencePlaceholder, setReferencePlaceholder] = useState<string>(
    t('LABEL_REFERENCE').toUpperCase()
  );

  const formatReference = (inputValue: string) => {
    const reference = inputValue.replace('.', '').replace('_', '');
    if (reference.length <= 0) {
      setReference('');
    }
    const ref = `${reference.slice(0, 3)}${
      reference.length > 3 ? '.' : ''
    }${reference.slice(3, 7)}`;
    setReference(ref.toUpperCase());
  };

  return (
    <div
      className={classnames(styles.cell, {
        [styles.mediaMobile]: mediaMobile,
      })}
      id="field-reference"
    >
      <TextField
        classes={{ root: styles.referenceInput }}
        error={hasStock && !!errorMsg}
        helperText={errorMsg}
        FormHelperTextProps={{ classes: { root: styles.helperText } }}
        InputProps={{
          classes: {
            root: styles.root,
            notchedOutline: !errorMsg ? styles.notchedOutline : '',
            input: styles.input,
            error: styles.error,
          },
          inputProps: { maxLength: 8 },
          endAdornment: hasStock && (
            <InputAdornment position="end">
              <img
                src={isValidReference && !errorMsg ? CorrectIcon : WrongIcon}
                alt={`${
                  isValidReference && !errorMsg ? 'correct' : 'wrong'
                }-reference`}
              />
            </InputAdornment>
          ),
        }}
        onBlur={() =>
          setReferencePlaceholder(t('LABEL_REFERENCE').toUpperCase())
        }
        onChange={ev => formatReference(ev.target.value)}
        onFocus={() => setReferencePlaceholder('___.____')}
        id="reference"
        placeholder={referencePlaceholder}
        value={reference}
        variant="outlined"
      />
    </div>
  );
}

export default ReferenceField;
